import React, { memo } from 'react';
import Accordion from '@wconcept/wconcept-ui-renewal/src/components/molecules/Accordion';
import * as S from './style';

interface IProps {
  /** children */
  children?: React.ReactNode;
  /** selectedValue */
  selectedValue?: string;
}

const AccrdnNoticeType = ({ selectedValue, children }: IProps) => (
  <S.AccrdnNoticeType>
    <Accordion selectedValue={selectedValue}>{children}</Accordion>
  </S.AccrdnNoticeType>
);

export default memo(AccrdnNoticeType);
